<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div>
        <div class="md-layout text-center">
          <div class="md-layout-item md-size-80 mt-4 md-small-size-100">
            
            <md-field class="md-form-group">
              <md-icon>email</md-icon>
              <div class="md-layout-item">
                <p class="form-control-static user-email">{{client.email}}</p>
              </div>
              <a href="#" @click.prevent="changeEmail()">
                <button type="button" class="md-button md-input-action change-email-button" tabindex="-1">
                    <i class="md-icon change-email-icon">edit</i>
                </button>
                <span class="change-email-text">Usar outro email</span>
              </a>
            </md-field>      

            <ValidationProvider
              name="fullName"              
              :rules="{
                required: true, 
                regex: /(\D{2,})\s(.{2,})/ 
              }"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Nome completo</label>
                <md-input v-focus autocomplete="name" v-model="fullName" type="text"> </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>

            <!--md-datepicker class="md-datepicker-blue" v-model="birthday" autocomplete="off" model-type="date">
              <label>Data de nascimento</label>
            </md-datepicker-->

            <ValidationProvider
              name="phone"              
              :rules="{
                required: true, 
                regex: /\([1-9]{2}\)[9]{0,1}[0-9]{4}-[0-9]{4}/
              }"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>phone</md-icon>
                <label>Telefone Celular</label>
                <md-input autocomplete="off" v-mask="phoneMask" v-model="phone" type="text"> </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>

            <ValidationObserver>
              <ValidationProvider                  
                name="password"              
                :rules="{
                  required: true, 
                  regex: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
                }"
                v-slot="{ passed, failed }"
              >
                <md-field 
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                >
                  <md-icon>lock</md-icon>
                  <label>Cadastre sua senha</label>
                  <md-input ref="password" autocomplete="password" v-model="password" type="password"></md-input>                  
                </md-field>
                <span v-show="failed" class="passwd-info">Sua senha deve conter 8 caracteres com letras maiúsculas, minúsculas e números</span>
              </ValidationProvider>

              <ValidationProvider                  
                name="passwordconfirm"              
                :rules="{
                  required: true, 
                  password: password,
                  regex: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
                }"
                v-slot="{ passed, failed }"
              >
                <md-field 
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                >
                  <md-icon>lock</md-icon>
                  <label>Confirme a senha</label>
                  <md-input ref="passwordcheck" v-model="passwordcheck" type="password" @keyup="nextKey"></md-input>
                </md-field>
              </ValidationProvider>
            </ValidationObserver>

          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { regex, required, is, min } from "vee-validate/dist/rules";
extend("required", required);
extend("regex", regex);
extend("is", is);
extend("min", min);

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Password confirmation does not match'
});


export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      client: this.$store.state.client,

      fullName: "",
      phone: this.$store.state.client.phone,
      password: "",
      birthday: "",

      phoneMask: "(##)####-####",
      passwordcheck: "",

      loadingData: true,
    };
  },

  mounted: function () {
    this.$nextTick(function () {
      this.$debug('loading FirstStep:');
      this.$debug(this.client);
      this.$material.locale.dateFormat = "dd/MM/yyyy";

      if (this.client.firstName) this.fullName = this.client.firstName;
      if (this.client.lastName) this.fullName += " " + this.client.lastName;
    })
  },
  
  watch: {
    phone: function(val){
      if (val[4] == '9') 
        this.phoneMask = "(##)#####-####";
      else this.phoneMask = "(##)####-####";
    }

  },

  methods: {
    validate() {
      return this.$refs.form.validate().then(res => {
        this.$emit("on-validated", res);
        return res;
      });
    },

    changeEmail(){ 
      this.$functions.resetAll(); 
      this.$router.push({ path: '/' });
    },

    nextKey: function(e) {      
      if (e && e.keyCode === 13) {        
        this.$emit('next');
      }      
    },    
  }
};
</script>

<style lang="scss" scoped>
.user-email{
  text-align: left !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  color: #888;
}

.change-email-text{
  font-size: 16px;
  font-weight: 400;
  line-height: 35px;
}

.md-button .change-email-icon {
  color: #aaa !important;  
}

.change-email-button{
  display: none;
}

.passwd-info{
  color: red;
  font-size: 14px;
  line-height: 14px;
}

@media only screen and (max-width: 600px) {
  .change-email-button {
    display: block;
  }
  .change-email-text{
    display: none;
  }

  .user-email{
    font-size: 14px;
  }
}

</style>
